import React from 'react';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import CustomBlockCard from '../explainBuyPage/customBlockCards';
import ImageBlockOne from '../../assets/images/blockSix_1.png';
import ImageBlockTwo from '../../assets/images/blockThree_1.png';
import ImageBlockedThree from '../../assets/images/blockFour_1.png';
import ImageBlockedFour from '../../assets/images/blockOne_1.png';
import { useTranslation } from 'react-i18next';
const BlockedItems =()=>{
      const {t} =useTranslation();
    return(
        <div className='w-full pb-5'>
            <div className="flex items-center gap-2">
                <NoSymbolIcon className="w-3 h-3 text-black md:w-6 md:h-6" />
                <h2 className="text-xl font-medium text-black md:text-3xl ">
                  {t("ProhibitedItemsTitle")}
                </h2>
            </div>   
        
        <div className='grid w-full grid-cols-2 gap-4 md:grid lg:my-5 md:grid-cols-4'>
          <div>
            <CustomBlockCard
              image={ImageBlockOne}
              title={t("blockedItems.allLiquids")}
            />
          </div>
          <div>
            <CustomBlockCard
              image={ImageBlockTwo}
              title={t("blockedItems.batteries")}
            />
          </div>
          <div>
            <CustomBlockCard
              image={ImageBlockedThree}
              title={t("blockedItems.fakeBrands")}
            />
          </div>
          <div>
            <CustomBlockCard
              image={ImageBlockedFour}
              title={t("blockedItems.medicalSupplies")}
            />
          </div>
        </div>      
        
        {/* <BlockedItemsSlider /> */}
        </div>
    )
}

export default BlockedItems;